
import React from "react"
import ReactWOW from "react-wow"
import {useStaticQuery, graphql } from "gatsby"
import Badges from "../App/Badge"
import { Link } from "gatsby"



const Banner = () => {
  
  return (
    <div className="online-banking-page-container">
      <div className="container hero">
        <div className="row justify-content-center align-items-center">
          <div className="col-lg-12 my-5">
            <div className="hero-title-wrapper mt-5 text-align-center">
              <h1 className="hero-title">Welcome to</h1>
              <h1 className="hero-title"><span className="">Internet Access </span><ReactWOW delay=".5s" animation="fadeInDown">
              </ReactWOW></h1>       
            </div>
            <h2 className="mb-4">We make simple, convenient and more secure payments possible anytime, anywhere with any device.</h2>
          </div>          
        </div>
        <div className="row mb-5">
          <div className="col-12">  
            {/* <div class="online-banking-widget">
                <p>Select internet banking based on your BSB number</p>
                <div className="row">
                    <div className="col-12 col-lg-6 default-btn">702-746 <i className="bi bi-arrow-right-circle"></i></div>
                    <div className="col-12 col-lg-6 default-btn">034-111 <i className="bi bi-arrow-right-circle"></i></div> 
                </div>
            </div>        */}

            <div className="online-banking-widget">
                <p>Select internet banking based on your BSB number</p>
                <div className="row">
                  <div className="col-12 col-md-6">
                    <Link
                      to="https://online.originmms.com.au/ib/oxygen"
                      activeClassName="active"
                      className="default-btn"
                    >
                       702-746
                      <i className="bi bi-arrow-right-circle"></i>
                    </Link>
                  </div>
                  <div className="col-12 col-md-6 mt-2 mt-md-0">
                    <Link
                      to="https://online.sourcefunding.com.au/security/login"
                      activeClassName="active"
                      className="default-btn"
                    >
                       034-111
                      <i className="bi bi-arrow-right-circle"></i>
                    </Link>
                    {/* Placeholder component */}
                    {/* <div className="btn-placeholder">
                      <p className="tag">Stay Tuned</p>
                      <p className="content">Banking services for 034-111 coming soon!</p>
                    </div> */}
                  </div>
                </div>
            </div>
            
          </div>
        </div>
      </div>

    </div>
  )
}

export default Banner